/**
 * Siltcon Auréa: video van een klant in de productgalerij.
 * De scherpe video staat in het midden; links en rechts loopt dezelfde video groot en wazig mee als achtergrond.
 * De achtergrondvideo laadt pas bij de eerste keer afspelen en volgt de hoofdvideo (spelen, pauze, spoelen).
 */
class AureaKlantvideo extends HTMLElement {
  connectedCallback() {
    const achtergrond = this.querySelector('.aurea-video__achtergrond');
    const video = this.querySelector('video:not(.aurea-video__achtergrond)');
    if (!achtergrond || !video) return;
    achtergrond.muted = true;

    const volg = () => {
      if (Math.abs(achtergrond.currentTime - video.currentTime) > 0.25) achtergrond.currentTime = video.currentTime;
    };
    const start = () => {
      if (!achtergrond.src && achtergrond.dataset.src) achtergrond.src = achtergrond.dataset.src;
      volg();
      achtergrond.play().catch(() => {});
      this.classList.add('aurea-video--speelt');
    };
    video.addEventListener('play', start);
    video.addEventListener('playing', start);
    video.addEventListener('pause', () => { achtergrond.pause(); volg(); });
    video.addEventListener('ended', () => achtergrond.pause());
    video.addEventListener('seeked', volg);
    video.addEventListener('timeupdate', volg);
  }
}

if (!customElements.get('aurea-klantvideo')) {
  customElements.define('aurea-klantvideo', AureaKlantvideo);
}
